// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZWVr","col":"styles_col__3er_6","actions":"styles_actions__3jdT2","conflict":"styles_conflict__2v7Cy"};